module.exports = __webpack_public_path__ + "static/media/vegetarian.d87ccf3f.svg";